'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRenderToJson = require('react-render-to-json');

var _reactRenderToJson2 = _interopRequireDefault(_reactRenderToJson);

var _flubber = require('flubber');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */

// TODO: Only work for mcs-lite-icon
var getPath = function getPath(children) {
  var json = (0, _reactRenderToJson2.default)(children);
  var path = json.children[0].children[0].attributes.d;
  return path;
};

var easeInOut = function easeInOut(t) {
  return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};

var MorphReplace = function (_React$PureComponent) {
  _inherits(MorphReplace, _React$PureComponent);

  function MorphReplace(props) {
    _classCallCheck(this, MorphReplace);

    var _this = _possibleConstructorReturn(this, (MorphReplace.__proto__ || Object.getPrototypeOf(MorphReplace)).call(this, props));

    _this.state = { d: getPath(props.children) };
    _this.rafId = null; // Remind: for canceling
    return _this;
  }

  _createClass(MorphReplace, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var fromPath = getPath(this.props.children);
      var toPath = getPath(nextProps.children);
      if (fromPath === toPath) return;

      var current = (0, _flubber.splitPathString)(fromPath);
      var next = (0, _flubber.splitPathString)(toPath);
      var interpolator = void 0;
      if (current.length === next.length) {
        // n-to-n
        interpolator = (0, _flubber.interpolateAll)(current, next, { single: true });
      } else if (current.length === 1) {
        // 1-to-n, 1-to-1
        interpolator = (0, _flubber.separate)(current[0], next, { single: true });
      } else if (next.length === 1) {
        // n-to-1
        interpolator = (0, _flubber.combine)(current, next[0], { single: true });
      } else {
        // TODO: n-to-m, NOT animate well.
        interpolator = (0, _flubber.interpolate)(fromPath, toPath);
      }

      var start = null;

      var drawLoop = function drawLoop(timestamp) {
        var progress = null;
        if (start === null) start = timestamp;
        progress = timestamp - start;
        var value = easeInOut(progress / 300);
        _this2.setState({ d: interpolator(Math.min(value, 1)) });
        if (progress < 300) {
          _this2.rafId = window.requestAnimationFrame(drawLoop);
        }
      };

      this.rafId = window.requestAnimationFrame(drawLoop);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.cancelAnimationFrame(this.rafId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          width = _props.width,
          height = _props.height,
          otherProps = _objectWithoutProperties(_props, ['children', 'width', 'height']);

      return _react2.default.createElement(
        'svg',
        Object.assign({ viewBox: '0 0 24 24', width: width, height: height }, otherProps),
        _react2.default.createElement('path', { d: this.state.d })
      );
    }
  }]);

  return MorphReplace;
}(_react2.default.PureComponent);

MorphReplace.propTypes = {
  children: _propTypes2.default.element.isRequired,
  width: _propTypes2.default.number,
  height: _propTypes2.default.number
};
MorphReplace.defaultProps = {
  width: 24,
  height: 24
};
exports.default = MorphReplace;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/MorphReplace/MorphReplace.js
// module id = 1091
// module chunks = 3